import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, inject, Inject, OnInit, PLATFORM_ID, ViewChild, HostListener, ElementRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChartData, ChartEvent, ChartType, ChartConfiguration } from 'chart.js';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { Api } from '../../services/api';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mdl-chart-info',
  imports: [BaseChartDirective, CommonModule, FormsModule],
  templateUrl: './mdl-chart-info.html',
  styleUrl: './mdl-chart-info.css',
  providers: [provideCharts(withDefaultRegisterables())]
})
export class MdlChartInfo implements OnInit, AfterViewInit{
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;
  
  public showMenu = false;
  public selectedChart: 'doughnut' | 'bar' = 'doughnut';

  public slcOptions: any = [];

  public mode: string = "acc";
  public graphValue: string = "1";
  public stats: any = [];
  public totales: any = [];
  public dataLabels: any = [];
  private api = inject(Api);
  title = 'ng2-charts-demo';
  isBrowser: boolean = false;

  public doughnutChartLabels: string[] = [ 'Sebastian', 'Luis', 'Maxi' ];
  public doughnutChartDatasets: ChartData<'doughnut'>['datasets'] = [
    { 
      data: [], 
      label: 'Prospectos',
      backgroundColor: ['#F47C2C', '#FABB61', '#D84E1F', '#F47C2C', '#FABB61', '#D84E1F']
    }
  ];
  public doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: false
  };

  public barChartLabels: string[] = [];
  public barChartDatasets: ChartData<'bar'>['datasets'] = [
    { 
      data: [], 
      label: 'Prospectos',
      backgroundColor: [] 
    }
  ];
  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: false,
    plugins: { legend: { display: false } },
    scales: {
      x: { display: false },
      y: { 
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return Number(value).toString();
          }
        }
      }
    }
  };


  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    public mdl: MatDialogRef <MdlChartInfo>,
    private elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    
  }

  ngOnInit(): void {
    this.mode = this.data.mode;
    this.isBrowser = isPlatformBrowser(this.platformId); 
    this.slcOptions = [];
    if(this.mode === 'pro'){
      this.slcOptions = [
        {value: 1, opt: 'Prospectos por usuario'},
        {value: 2, opt: 'Prospectos por origen'}
      ]
    }else if(this.mode ==='acc'){
      this.slcOptions = [
        {value: 1, opt: 'Total de contactos y cuentas'},
        {value: 2, opt: 'Total de cuentas por industria'},
        {value: 3, opt: 'Total de cuentas asignadas por ejecutivo'},
      ]
    }

    this.graphValue = this.slcOptions[0].value;
    if(this.mode === 'pro'){
      this.getProspectStats();
    }else if(this.mode === 'acc'){
      this.getContactAccountStats();
    }
  }

  ngAfterViewInit(): void {
    this.chart?.update();
  }

  // **** Graficos Prospectos ****

  getProspectStats(){
    this.api.getProspectStats({}).subscribe({
      next: (data: any) => {
        this.stats = data.data;

        this.totales = [];
        this.dataLabels = [];
        const randomColors: string[] = [];

        for (let i = 0; i < this.stats.length; i++) {
          this.totales.push(this.stats[i].total);
          this.dataLabels.push(this.stats[i].nombre + ' ' + this.stats[i].apellido);
          randomColors.push(this.getRandomColor());
        }

        this.doughnutChartLabels = this.dataLabels;
        this.doughnutChartDatasets[0].data = this.totales;
        this.doughnutChartDatasets[0].backgroundColor = randomColors;

        this.barChartLabels = this.dataLabels;
        this.barChartDatasets[0].data = this.totales;
        this.barChartDatasets[0].backgroundColor = randomColors;

        this.chart?.update();
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }

  getProspectOriginStats(){
    this.api.getProspectOriginStats({}).subscribe({
      next: (data: any) => {
        this.stats = data.data;

        this.totales = [];
        this.dataLabels = [];
        const randomColors: string[] = [];

        for (let i = 0; i < this.stats.length; i++) {
          this.totales.push(this.stats[i].total);
          this.dataLabels.push(this.stats[i].p_origen);
          randomColors.push(this.getRandomColor());
        }

        this.doughnutChartLabels = this.dataLabels;
        this.doughnutChartDatasets[0].data = this.totales;
        this.doughnutChartDatasets[0].backgroundColor = randomColors;

        this.barChartLabels = this.dataLabels;
        this.barChartDatasets[0].data = this.totales;
        this.barChartDatasets[0].backgroundColor = randomColors;

        this.chart?.update();
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }

  // **** Graficos Cuentas ****

  getContactAccountStats(){
    this.api.getTotalContactAccount({}).subscribe({
      next: (data:any)=>{
        this.stats = data.data;

        this.totales = [];
        this.dataLabels = [];

        const randomColors: string[] = [];

        for (let i = 0; i < this.stats.length; i++) {
          this.totales.push(this.stats[i].total);
          this.dataLabels.push(this.stats[i].tipo);
          randomColors.push(this.getRandomColor());
        }

        this.doughnutChartLabels = this.dataLabels;
        this.doughnutChartDatasets[0].data = this.totales;
        this.doughnutChartDatasets[0].backgroundColor = randomColors;

        this.barChartLabels = this.dataLabels;
        this.barChartDatasets[0].data = this.totales;
        this.barChartDatasets[0].backgroundColor = randomColors;

        this.chart?.update();
      },
      error: (err: any) =>{
        console.error(err);
      }
    })
  }

  getAccountIndustryStats(){
    this.api.getAccountIndustryStats({}).subscribe({
      next: (data: any) => {
        this.stats = data.data;

        this.totales = [];
        this.dataLabels = [];
        const randomColors: string[] = [];

        for (let i = 0; i < this.stats.length; i++) {
          this.totales.push(this.stats[i].total);
          this.dataLabels.push(this.stats[i].c_industria);
          randomColors.push(this.getRandomColor());
        }

        this.doughnutChartLabels = this.dataLabels;
        this.doughnutChartDatasets[0].data = this.totales;
        this.doughnutChartDatasets[0].backgroundColor = randomColors;

        this.barChartLabels = this.dataLabels;
        this.barChartDatasets[0].data = this.totales;
        this.barChartDatasets[0].backgroundColor = randomColors;

        this.chart?.update();
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }

  getAccountStats(){
    this.api.getAccountStats({}).subscribe({
      next: (data: any) => {
        this.stats = data.data;

        this.totales = [];
        this.dataLabels = [];
        const randomColors: string[] = [];

        for (let i = 0; i < this.stats.length; i++) {
          this.totales.push(this.stats[i].total);
          this.dataLabels.push(this.stats[i].nombre + ' ' + this.stats[i].apellido);
          randomColors.push(this.getRandomColor());
        }

        this.doughnutChartLabels = this.dataLabels;
        this.doughnutChartDatasets[0].data = this.totales;
        this.doughnutChartDatasets[0].backgroundColor = randomColors;

        this.barChartLabels = this.dataLabels;
        this.barChartDatasets[0].data = this.totales;
        this.barChartDatasets[0].backgroundColor = randomColors;

        this.chart?.update();
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }

  getBackgroundColor(index: number): string {
    const dataset = this.doughnutChartDatasets[0];
    if (dataset && Array.isArray(dataset.backgroundColor)) {
      return dataset.backgroundColor[index] as string || '#000000';
    }
    return '#000000';
  }

  getRandomColor(): string {
    const hue = 30;
    const saturation = Math.floor(Math.random() * 20) + 70; 
    const lightness = Math.floor(Math.random() * 30) + 40;

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }


  getData(index: number): number {
    const dataset = this.doughnutChartDatasets[0];
    return dataset?.data?.[index] || 0;
  }

  closeMdl(){
    this.mdl.close();
  }

  showGraphSelection(){
    this.showMenu = !this.showMenu;
  }

  selectGraph(type: 'doughnut' | 'bar') {
    this.selectedChart = type;
  }

  changeGraphData(){
    if(this.mode === 'pro'){
      if(this.graphValue === "1"){
        this.getProspectStats();
      }else if(this.graphValue === "2"){
        this.getProspectOriginStats();
      }
    }else if(this.mode === 'acc'){
      if(this.graphValue === "1"){
        this.getContactAccountStats();
      }else if(this.graphValue === "2"){
        this.getAccountIndustryStats();
      }else if(this.graphValue === "3"){
        this.getAccountStats();
      }
    }

  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null): void {
    if (!(target instanceof HTMLElement)) return;
    
    const clickedInsideRecent = this.elementRef.nativeElement.querySelector('.dropdown-trigger')?.contains(target);
    const clickedInsideActions = this.elementRef.nativeElement.querySelector('.dots-button')?.contains(target);
    
    if (!clickedInsideRecent) {
      this.showMenu = false;
    }

  }
}